<template>
  <section id="app-main" class="app-main">
    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->
    <router-view v-slot="{ Component }">
      <keep-alive :include="cachedViews">
        <transition name="fade-transform" mode="out-in">
          <component :is="Component" :key="key" class="app-main__view" />
        </transition>
      </keep-alive>
    </router-view>
    <!-- <transition name="fade-transform" mode="out-in">
      <router-view :key="key" class="app-main__view" />
    </transition> -->
    <!-- <router-view v-slot="{ Component }">
      <transition>
        <component :is="Component" />
      </transition>
    </router-view> -->
  </section>
</template>

<script>
// import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'AppMain',
  components: {
    // Breadcrumb
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.module.scss";

.app-main {
  /* 50= navbar  50  */
  background: #F8F8F8;
  min-height: calc(100vh - 80px);
  position: relative;
  overflow: auto;
}

.app-main__view{
  /*padding: 20px;*/
  padding: 24px;
  min-height: calc(100vh - 80px);
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
 .el-breadcrumb{
  display: inline-block;
  font-size: 14px;
  width: 100% !important;
  // line-height: 70px;
  padding-left: 30px;
  margin-left: 0px !important;
  background-color: #ffffff !important;
}
</style>
